import router from '@/router'
import { Scroll, VueScrollReveal } from '@/utils/'
import Vue from 'vue'
import VueGtag from 'vue-gtag'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import VueLazyLoad from 'vue-lazyload'
import VueMasonry from 'vue-masonry-css'
import App from './App.vue'
import './assets/styles/_index.scss'
import store from './store/index.js'

Vue.use(Scroll)
Vue.use(VueScrollReveal, {
  duration: 800,
  scale: 0.85,
  distance: '20px'
})

Vue.use(VueGtag, {
  config: { id: 'UA-159652083-1' }
})
Vue.use(VueLazyLoad)

Vue.config.productionTip = false
Vue.use(VueMasonry)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
